import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { editIcon } from '../../../config/variables';
import DeleteButton from '../../../components/buttons/DeleteButton';

const StepsTable = ({ tableHeaders, data, noDataMessage, setRefetchData, productId, lessColumns }: any) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'}`}>
      <div className="table_header">
        {tableHeaders?.map((header: any, index: number) => (
          <span className={`head ${header.customClass}`} key={index}>
            {header.label}
          </span>
        ))}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'} `}>
        {data?.length > 0 ? (
          <>
            {data?.map((item: any, index: number) => (
              <div
                className="item has_logo clickable"
                key={index}
                onClick={(e) => {
                  navigateRoute(e, `/order-steps/create-order-step/${item.id}`, navigate);
                }}
              >
                <div className="column text-center capitalize">{item?.name.en || '-'}</div>
                <div className="column text-center">{item?.name.ar || '-'}</div>
                <div className="column text-center">{item?.order || '-'}</div>
                {
                  hasPermission(['order_steps.edit'])
                  && (
                    <div className="column actions actions_col">
                      <div
                        className="action_btn edit"
                        onClick={(e) => {
                          navigateRoute(e, `/order-steps/create-order-step/${item.id}`, navigate);
                        }}
                      >
                        {editIcon}
                      </div>
                      <DeleteButton deleteRoute={`/admin/order-steps`} queryKey='order-steps' id={item.id} />
                    </div>
                  )}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default StepsTable;
